import React, { useState, useEffect } from 'react';

function ToggleButton({ leftLabel = 'True', rightLabel = 'False', value =true, onToggle, style, disabled = false }) {
  const [selected, setSelected] = useState(value);

  const handleClick = (e) => {
    if (onToggle) onToggle(e);
  };
  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div style={{...styles.btnStyle, style}}>
      <div style= {{...styles.background,
        left: selected ? '0%' : '50%',
        transition: 'left 0.3s ease',
        backgroundColor: disabled ? "dddde2": "rgb(100, 112, 221)",
        cursor: disabled ? "default" : "cursor"
      }}></div>
      <div onClick={() => handleClick(true)}
        style={{...styles.btnContents,
          color: selected ? "white" : "black"
        }}>
        {leftLabel}
      </div>
      <div onClick={() => handleClick(false)}
        style={{...styles.btnContents,
          color: !selected ? "white" : "black"
        }}>
        {rightLabel}
      </div>
    </div>
  );
}

const styles = {
  btnStyle : {
    display: 'flex', borderRadius: 8, overflow: 'hidden', border: '1px solid #ccc', width: 250, height: 60,
    justifyContent: 'center', alignItems: 'center', position: "relative", 
  },
  btnContents : {
    display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, zIndex: 999, cursor: "pointer", height: "100%"
  },
  background: {
    width: "50%", height: "100%", position: "absolute", 
    borderRadius: "8px", background: "rgb(100, 112, 221)",
    zIndex: 1
  }
}

export default ToggleButton;